/**
 * Route access model, mirroring the sidebar's role-based visibility in
 * DefaultLayout: students use the student-* pages, staff/teaching roles get
 * the management pages. The router guard redirects anyone whose role is not
 * listed for the matched prefix to the dashboard, so a wrong URL shows no
 * page shell at all (the backend permission middleware stays the real gate).
 */
const ADMIN = ["administrator", "super-administrator"];
const ADMIN_TU = [...ADMIN, "tu"];
const TEACHING = [...ADMIN_TU, "teacher"];

export const routeRoleMap: Record<string, string[]> = {
    // Admin only — tu/teacher/students use dedicated flows or have no access
    "/users": ADMIN_TU,
    "/roles": ADMIN,
    "/permissions": ADMIN,
    "/academic-years": ADMIN,
    "/majors": ADMIN,
    "/semesters": ADMIN,
    "/teachers": ADMIN,
    "/students": ADMIN,

    // Staff management — tu + admin
    "/classes": ADMIN_TU,
    "/subjects": ADMIN_TU,
    "/class-subjects": ADMIN_TU,
    "/student-classes": ADMIN_TU,

    // Learning modules
    "/materials": ["teacher", ...ADMIN],
    "/assignments": TEACHING,
    "/assignment-grading": ["teacher", ...ADMIN],
    "/question-banks": TEACHING,
    "/exams": TEACHING,

    // Per-module pages for other roles live under student-* routes
    "/attendance": TEACHING,
    "/reports": TEACHING,

    // AI — assistant for teaching staff, provider management for admins
    "/ai-assistant": ["teacher", ...ADMIN],
    "/ai-providers": ADMIN,
};

export function rolesForPath(path: string): string[] | undefined {
    const matches = Object.keys(routeRoleMap)
        .filter((prefix) => path === prefix || path.startsWith(prefix + "/"))
        .sort((a, b) => b.length - a.length);

    return matches.length > 0 ? routeRoleMap[matches[0]] : undefined;
}
